<!-- 房源排序管理 -->
<template>
  <el-main>
    <div class="tableList">
      <div class="tableContent">
        <div class="ele-table-tool-default">
          <el-button size="small" type="primary" icon="el-icon-plus" :style="{backgroundColor: $store.state.activeColor,borderColor: $store.state.activeColor}" @click="addListingSorting">新建</el-button>
          <el-button size="small" type="primary" icon="el-icon-minus" :style="{backgroundColor: $store.state.deleteColor,borderColor: $store.state.deleteColor}" @click="delListingSorting">删除</el-button>
        </div>
        <el-table
          @selection-change="handleSelectionChange"
          row-key="id"
          class="table"
          ref="tableData"
          :data="table.tableData"
          border
          :height="table.tableHeight"
          element-loading-text="拼命加载中,请等待"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.1)"
        >
          <el-table-column width="45" type="selection" :reserve-selection="true" align="center"></el-table-column>
          <el-table-column width="100" prop="id" label="序号" align="center">
            <template slot-scope="scope">
              <span>{{ (paging.page-1)*paging.size+scope.$index+1 }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="orderinfo"  label="排序" align="center">
            <template slot-scope="scope">
              <el-button type="text" icon="el-icon-bottom" :style="{color: $store.state.activeColor, padding:0, fontSize:'20px'}" @click="orderInfo('down', scope.row)"></el-button>
              <el-button type="text" icon="el-icon-top" :style="{color: $store.state.activeColor, padding:0, fontSize:'20px'}" @click="orderInfo('up', scope.row)"></el-button>
            </template>
          </el-table-column>
          <el-table-column prop="title" label="标题" align="center" width="300px"></el-table-column>
          <el-table-column prop="city" label="城市" align="center" width="200px"></el-table-column>
          <el-table-column prop="no" label="房源编号" align="center" width="200px"></el-table-column>
          <el-table-column prop="facilityServices" label="设施服务" align="center" width="400px"></el-table-column>
          <el-table-column prop="facilityServicesTop" label="卖点标签" align="center" width="400px"></el-table-column>
          <el-table-column prop="regionKeyword" label="区域" align="center" width="400px"></el-table-column>
          <el-table-column prop="schoolKeyword" label="学校" align="center" width="400px"></el-table-column>
          <el-table-column prop="landmarkKeyword" label="地标" align="center" width="400px"></el-table-column>
          <el-table-column prop="houseInfo" label="房屋信息" align="center" width="400px"></el-table-column>
          <el-table-column prop="price" label="价格" align="center" width="400px"></el-table-column>
          <el-table-column label="操作" align="center" width="100" fixed="right">
            <template slot-scope="scope">
              <el-popconfirm class="real_pop" title="您确定要删除房源信息吗？" @confirm="handleOperation(scope.row)">
                <el-button class="danger" :style="{marginLeft:'0px !important'}" slot="reference" type="text" size="mini" :icon="scope.row.status ? 'el-icon-circle-check':'el-icon-circle-close'">删除</el-button>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="tablePagination">
        <el-pagination
          class="customPagination"
          @size-change="handlePaginationChange"
          @current-change="handlePaginationCurrentChange"
          :current-page="paging.page"
          :page-sizes="[15, 25, 50]"
          :page-size="paging.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="paging.total"
        >
        </el-pagination>
      </div>
    </div>
  </el-main>
</template>

<script>
  export default {
    name: 'ListingSortingManagement',
    data () {
      return {
        formInline: { // 查询参数
          keyWord: '' ,// 关键字
          cityName: '', // 城市
          regionName: '', // 区域
          priceName: '', // 价格
          parentId: '', // 父id
        },
        table: { // 表格参数
          tableData:[], // 表格数据
          tableHeight: null, // 表格高度
        },
        paging: { // 分页参数
          page: 1,// 页码
          size: 15, // 条数
          total: 0, // 总数
        },
        checkIds:[], // 所选列表
      }
    },
    methods: {
      // 获取表格数据
      getList(){
        this.$api.houseSearchTopping({
          page:this.paging.page,
          size:this.paging.size,
          apartmentClassify:"",
          cityKeyword:this.formInline.cityName,
          keyword:this.formInline.keyWord,
          mode: "",
          parentId:this.formInline.parentId,
          price:this.formInline.priceName,
          regionKeyword:this.formInline.regionName,
        }).then(res => {
          if (res.data.status == 200) {
            this.table.tableData = res.data.data.records;
            this.paging.total = Number(res.data.data.total);
            if(this.table.tableData != ""){
              this.$nextTick(() => {
                this.$refs.tableData.clearSelection();
              })
            }
          } else {
            this.$message({
              type: 'error',
              message: res.data.message
            });
          }
        });
      },
      // 分页部分改变条数
      handlePaginationChange(val) {
        this.paging.size = val;
        this.paging.page = 1;
        this.getList();
      },
      // 分页部分改变页码
      handlePaginationCurrentChange(val) {
        this.paging.page = val;
        this.getList();
      },
      // 切换选择
      handleSelectionChange(val) {
        this.checkIds = [];
        if (val.length > 0) {
          for (let i = 0; i < val.length; i++) {
            this.checkIds.push(val[i].id);
          }
        }
      },
      // 新建ListingSorting
      addListingSorting(){
        this.$router.push({
          path:'/ListingSortingManagementOperation',
        });
      },
      // 批量删除ListingSorting
      delListingSorting(){
        this.$api.houseDeleteTopping({ ids: this.checkIds.toString() }).then(res => {
          if (res.data.status == 200) {
            this.$message({
              message: "删除成功",
              type: 'success'
            });
            this.getList();
          } else {
            this.$message({
              type: 'error',
              message: res.data.message
            });
          }
        });
      },
      // 编辑/删除
      handleOperation(row){
        this.$api.houseDeleteTopping({ ids: row.id }).then(res => {
          if (res.data.status == 200) {
            this.$message({
              message: "删除成功",
              type: 'success'
            });
            this.getList();
          } else {
            this.$message({
              type: 'error',
              message: res.data.message
            });
          }
        });
      },
      // 改变orderInfo顺序
      orderInfo(type,data){
        if (this.table.tableData.length <=1){
          this.$message({
            message: '没有足够多的数据不能改变顺序！',
            type: 'warning'
          });
          return;
        }
        if (type == "up"){
          this.$api.houseUpdataTopping({ id: data.id,variable:1}).then(res => {
            if (res.data.status == 200) {
              this.$message({
                message: '修改成功！',
                type: 'success'
              });
              this.getList();
            } else {
              this.$message({
                type: 'error',
                message: res.data.message
              });
            }
          });
        } else {
          this.$api.houseUpdataTopping({ id: data.id,variable:-1}).then(res => {
            if (res.data.status == 200) {
              this.$message({
                message: '修改成功！',
                type: 'success'
              });
              this.getList();
            } else {
              this.$message({
                type: 'error',
                message: res.data.message
              });
            }
          });
        }
      },
      // table的高度
      getTableHeight(){
        let that = this;
        if($(".table").length > 0) {
          // 表格高度初始化事件
          $(".table").height(window.innerHeight - $(".table").offset().top - 70);
          $(".table .el-table__empty-block").height(window.innerHeight - $(".table").offset().top - 132);
          that.table.tableHeight = window.innerHeight - $(".table").offset().top - 70;
          // 窗口改变事件
          window.onresize = function () { // 定义窗口大小变更通知事件
            if($(".table").length > 0) {
              $(".table").height(window.innerHeight - $(".table").offset().top - 70);
              $(".table .el-table__empty-block").height(window.innerHeight - $(".table").offset().top - 132);
              that.table.tableHeight = window.innerHeight - $(".table").offset().top - 70;
            }
          };
        }
      },
    },
    mounted() {
      // 获取页面表格高度
      this.getTableHeight();
      // 获取列表
      this.getList();
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  @import "../../assets/css/detaileds.css";/* 列表样式 */
</style>





// WEBPACK FOOTER //
// src/components/Menu/ListingSortingManagement.vue